import { serializeOptions, TDefaultOptionResponse } from '@cannect/services/common'

export const serializeFiltersOptions = (list: TDefaultOptionResponse[], prefix?: string) => {
  const serializedOptions = serializeOptions(list) || []
  return serializedOptions.map((item) => ({ ...item, value: `${prefix ? `${prefix}:` : ''}${item.value}` }))
}
